export default function({ state, commit, dispatch }, ticket) {
    commit('startTicketingPatient', ticket.patient)


    return dispatch('patch', {
        url: '/provider/' + (state.id ? state.id : ticket.provider) + '/patient/' + ticket.patient + '/ticket/' + ticket.id,
        data: {
            status: ticket.status,
            comment: ticket.comment
        }
    }, {
        root: true
    })
    .then((response) => {
        commit('finishTicketingPatient', ticket.patient)
        commit('updatePatient', response)
        commit('updateTicket', response)
		return response
    })
    .catch((error) => {
        commit('finishTicketingPatient', ticket.patient)
		throw error
    })
}
